export function downloadFile(file: File): void {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.name;
  link.click();
  // revoke on the next tick so the browser has started the download
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
